import { createContext, useContext, type Provider } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { type UIConfig } from '../../../types';

const initialState: UIConfig = {
	fullScreen: false,
	externalEmbed: false,
	customHandlers: {
		handleDeepLinkClick: undefined,
		handleSubmitSmartCreate: () => {},
	},
	isBitbucketBetaEnabled: false,
	customFeedbackCategories: undefined,
	stagingAreaRef: undefined,
	promptInputDroppableUrls: undefined,
	enableBrowserContextBanner: false,
	browserContextSanitizer: undefined,
	elements: {
		closeButton: true,
		newChatButton: true,
		fullscreenButton: true,
		createAgentButton: true,
		browseAgentsButton: true,
		agentsMenu: true,
		navbar: true,
		mainChatHeader: true,
		stagingAreaEnabled: false,
		voiceDictationButton: false,
		fileUploadButton: true,
		chatModeMenuButton: true,
	},
};

export const uiConfigDefaults: UIConfig = initialState;

const uiConfig = createContext<UIConfig>(initialState);
export const UIConfigProvider: Provider<UIConfig> = uiConfig.Provider;
export const useUIConfig = (): UIConfig => useContext(uiConfig);

export const createUIConfig = (config?: Partial<UIConfig>): UIConfig => {
	// Allow fullscreen override for branch deploy testing purposes
	const processedConfig: Partial<UIConfig> | undefined =
		localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' &&
		fg('rovo_chat_show_local_frontend_components')
			? {
					...config,
					fullScreen: true,
				}
			: config;

	return {
		...{
			...initialState,
			...processedConfig,
			enableBrowserContextBanner:
				processedConfig?.enableBrowserContextBanner ?? initialState.enableBrowserContextBanner,
			browserContextSanitizer: processedConfig?.browserContextSanitizer,
			elements: {
				...initialState.elements,
				...processedConfig?.elements,
			},
			promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls,
		},
	};
};
